import { getIsDbhStaff } from '@dbh/dom';

const logTracking=function(){if(getIsDbhStaff()){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];console.log("[dbh][tracking]",...b);}// eslint-disable-next-line no-console
};const logTrackingError=function(){if(getIsDbhStaff()){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];console.error("[dbh][tracking][error]",...b);}// eslint-disable-next-line no-console
};

export { logTracking, logTrackingError };
